import * as React from 'react';
import type { SVGProps } from 'react';
export const SvgCloudCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    style={{
      color: 'inherit',
      ...props.style,
    }}
  >
    <path
      d="M24 11.113a5.765 5.765 0 0 0-5.216-5.952.25.25 0 0 1-.191-.12 7.684 7.684 0 0 0-14.1 2.294.25.25 0 0 1-.227.2A4.64 4.64 0 0 0 .624 9.774 4.47 4.47 0 0 0 0 12.223a4.3 4.3 0 0 0 1.235 3.1 4.6 4.6 0 0 0 1.78 1.062.963.963 0 0 0 1.243-.86v-.026a.985.985 0 0 0-.658-1.033 2.6 2.6 0 0 1-.96-.572A2.37 2.37 0 0 1 2 12.109a2.59 2.59 0 0 1 2.586-2.588 2.7 2.7 0 0 1 .535.054.99.99 0 0 0 .811-.184 1 1 0 0 0 .392-.779c.085-5.736 8.293-7.372 10.818-2.044a.97.97 0 0 0 .941.57 3.73 3.73 0 0 1 3 1.309 3.9 3.9 0 0 1 .9 2.812 3.43 3.43 0 0 1-1.473 2.667.97.97 0 0 0-.4.964l.01.059a.968.968 0 0 0 1.525.608A5.4 5.4 0 0 0 24 11.113"
      fill="currentColor"
    />
    <path
      d="M12.231 9.7a6.5 6.5 0 1 0 6.5 6.5 6.51 6.51 0 0 0-6.5-6.5m3.124 4.155a.75.75 0 0 1 .15 1.05l-2.905 3.87a1.5 1.5 0 0 1-1.1.6h-.111a1.49 1.49 0 0 1-1.055-.443l-1.5-1.5a.75.75 0 0 1 1.066-1.06l1.3 1.3a.25.25 0 0 0 .376-.026L14.305 14a.75.75 0 0 1 1.05-.149Z"
      fill="currentColor"
    />
  </svg>
);
